module.exports = __webpack_public_path__ + "img/comm-03-milestone-img-01.3819904b.jpg";